var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPagingPre(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    transform: "translate(0.5)",
    fill: "white",
    fillOpacity: 0.01
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(4.5 4)",
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.505 14.9951L18.098 10.4021C18.1896 10.3086 18.2988 10.2342 18.4193 10.1832C18.5398 10.1322 18.6692 10.1057 18.8001 10.105C18.9309 10.1043 19.0606 10.1296 19.1816 10.1794C19.3026 10.2292 19.4126 10.3024 19.5051 10.3949C19.5976 10.4875 19.6709 10.5974 19.7207 10.7184C19.7704 10.8395 19.7957 10.9691 19.7951 11.1C19.7944 11.2308 19.7678 11.3602 19.7168 11.4808C19.6658 11.6013 19.5915 11.7105 19.498 11.8021L15.598 15.7021L19.498 19.6021C19.6806 19.7883 19.7822 20.0392 19.7809 20.3C19.7796 20.5608 19.6754 20.8106 19.491 20.995C19.3065 21.1795 19.0568 21.2837 18.7959 21.285C18.5351 21.2863 18.2843 21.1846 18.098 21.0021L13.505 16.4101C13.3175 16.2225 13.2122 15.9682 13.2122 15.7031C13.2122 15.4379 13.3175 15.1836 13.505 14.9961V14.9951Z",
    fill: "black",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPagingPre);
export default __webpack_public_path__ + "static/media/pagingPre.cfe891c4ae411594c1e2be946c487975.svg";
export { ForwardRef as ReactComponent };